import React from 'react';
import PropTypes from 'prop-types';
import { Title } from 'smartsuite-ui';
import { useParams } from 'react-router-dom';
import BagDetail from './BagDetail';
import { useTranslation } from 'react-i18next';

const bagSelectorResultKeys = {
    bagTag: '',
    bagType: '',
    bagStatus: '',
    passengerName: '',
    pnr: '',
    frequentFlyerNumber: '',
    tracerReferenceId: '',
};
const headers = Object.keys(bagSelectorResultKeys);

function getHeaderLink(props, header, value) {
    if (!value) {
        return '';
    }

    if (header == 'tracerReferenceId') {
        return props.tracerDetailsLink + value || '';
    } else {
        return '';
    }
}

export default function BagSummaryHeader(props) {
    const { t } = useTranslation('bagSummary');
    const { id } = useParams();

    function renderBagDetails() {
        return headers.map((header) => {
            const value = props.bagSelectorResult[header];
            const key = t(header);
            const link = getHeaderLink(props, header, value);
            return <BagDetail key={header} item={{ key, value, link }} />;
        });
    }

    return (
        <div className="bag-summary-header">
            <div className="bag-summary-header__top">
                <Title>Bag Summary</Title>
                <div className="bag-summary-header__bag-details">
                    <a href={props.bagDetailsLink + id} target="_blank">
                        {t('bagDetails')}
                        <span
                            className="fas fa-external-link-alt"
                            style={{ marginLeft: '0.25rem' }}
                        ></span>
                    </a>
                </div>
            </div>
            <div className="bag-summary-header__bottom">
                {renderBagDetails()}
            </div>
        </div>
    );
}

BagSummaryHeader.propTypes = {
    bagSelectorResult: PropTypes.instanceOf(Object),
    bagDetailsLink: PropTypes.string,
    tracerDetailsLink: PropTypes.string,
};
